'use client';

import { useTranslations } from 'next-intl';

import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

interface UploadProgressProps {
  /** 0-100 upload percentage, or `null`/`undefined` while idle (renders nothing). */
  value: number | null | undefined;
  className?: string;
}

/**
 * Inline upload progress bar shown while a file/image transfer is in flight.
 * Reuses the shadcn `<Progress>` primitive and pairs it with a localized
 * "Uploading… {percent}%" caption. Renders nothing when `value` is null/undefined,
 * so it can be dropped in unconditionally next to any file field.
 */
function UploadProgress({ value, className }: UploadProgressProps) {
  const t = useTranslations('common');

  if (value === null || value === undefined) return null;

  return (
    <div className={cn('space-y-1', className)}>
      <Progress value={value} />
      <p className='text-muted-foreground text-xs'>
        {t('uploadingPercent', { percent: value })}
      </p>
    </div>
  );
}

export { UploadProgress };
